<template>
    <rkm-area
        background-color="primary"
        closed
        title="Marcadores de consumo alimentar"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    :title="item.objetivo.marcadorConsumoAlimentar.titulo"
                    type="fieldset"
                >
                    <FormQuestionario
                        v-if="item.objetivo.marcadorConsumoAlimentar.perguntas.length >= 1"
                        :questionario="questionario"
                        :required="false"
                        :titulo="item.objetivo.marcadorConsumoAlimentar.tituloArea"
                        readonly
                    />
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components
import FormQuestionario from '@/components/atencao-basica/marcador-consumo-alimentar/components/questionario/Form.vue'

export default {
    components: {FormQuestionario},
    computed: {
        questionario() {

            const perguntas = this.item.objetivo.marcadorConsumoAlimentar.perguntas.slice(0)

            perguntas.respostasMarcadas = this.item.objetivo.marcadorConsumoAlimentar.respostas

            return perguntas
        }
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>